/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function (Flits) {
  /* To load js in all pages */
  if (
    Flits.Metafields.IS_SOCIAL_LOGIN_PAID &&
    Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE
  ) {
    if (window.flitsObjects.allCssJs.socialLoginJs) {
      Flits.LoadStyleScript(
        "socialLoginJs",
        window.flitsObjects.allCssJs.socialLoginJs.url
      );
    }
  }
  if (
    Flits.Metafields.IS_WISHLIST_PAID &&
    Flits.Metafields.IS_WISHLIST_ENABLE
  ) {
    Flits(document).on("Flits:Loaded", function (event) {
      Flits.LoadStyleScript(
        "wishlistJs",
        window.flitsObjects.allCssJs.wishlistJs.url
      );
    });
  }
  if (location.pathname.indexOf("/account") != -1) {
    Flits(document).on("click", ".flits-custom-tab-add", function (e) {
      var elem = Flits(this).attr("href");
      var el = elem.replace("#", "");
      //Flits('.flits-account-container').addClass('flits-active');

      Flits(".flits-menu-nav .flits-menu-item").removeClass(
        "flits-menu-active"
      );
      Flits(".flits-custom-tab-add").removeClass("flits-menu-active");
      Flits('.flits-account-container a[href="' + elem + '"]')
        .closest(".flits-menu-item")
        .addClass("flits-menu-active");

      Flits(".flits-account-box").removeClass("flits-account-box-active");
      Flits(".flits-mobile-account-box").removeClass(
        "flits-account-box-active"
      );
      Flits("#flits_tab_" + el).addClass("flits-account-box-active");
      Flits("#flits_mobile_tab_" + el).addClass("flits-account-box-active");
      // To change the location.hash of the URL
      location.hash = el;
    });
  }

  //  Flits(document).on('Flits:WishlistAutomaticCode:Loaded', function(event){
  //    debugger;
  //    var data = event.detail;
  // var el = data.el;
  // var parent = data.parent;
  // var cloneNode = data.cloneNode;
  //    setTimeout(function(){  Flits(el).find('.default_sticky').append(cloneNode); }, 2000);
  //  });

  Flits(document).on(
    "wrapped:cart:updated Flits:Wishlist:AddCount Flits:Wishlist:RemoveCount",
    function (event) {
      setTimeout(function () {
        var grid = Flits("#CartDrawerForm .cart__items .cart__item").find(
          ".flits-wishlist-colection .flits-wls-button"
        );
        Flits(grid).each(function (index, single_grid_item) {
          var handle = Flits(single_grid_item).attr(
            "data-flits-product-handle"
          );
          Flits(single_grid_item).parent().css("display", "flex");
          Flits(single_grid_item)
            .find(".flits-wls-icon-with-text-text")
            .css("display", "flex");
          if (Flits.isProductAddedInWishlist(handle)) {
            Flits(single_grid_item).removeClass("flits-wls-inactive");
            Flits(single_grid_item).addClass("flits-wls-active");
            Flits(single_grid_item)
              .find(".flits-wls-icon-with-text-text")
              .html(
                Flits.t(
                  "Flits.locals.wishlisted_product_page.remove_from_wishlist_button",
                  "Remove from Wishlist"
                )
              );
          } else {
            Flits(single_grid_item).removeClass("flits-wls-active");
            Flits(single_grid_item).addClass("flits-wls-inactive");
            Flits(single_grid_item)
              .find(".flits-wls-icon-with-text-text")
              .html(
                Flits.t(
                  "Flits.locals.wishlisted_product_page.add_to_wishlist_button",
                  "Add to Wishlist"
                )
              );
          }
        });
      }, 2000);
    }
  );
})(Flits);
